export default __webpack_public_path__ + "static/media/yb.54a45cce.svg";